import * as CM from '@emersya/mpa-components-manager';
// import './MenuAccordion.scss';
import {IMenuComponentConfiguration, MenuComponent} from '../Menu/Menu';
import {SectionComponent} from '../../Section/Section';


// Two form of condition, serialized and deserialized.
interface TConditions<TCondition extends CM.Condition.TCondition | CM.Condition.TSerialized> {
	opening?: TCondition;
	closing?: TCondition;
};

type TConditionsPack<TCondition extends CM.Condition.TCondition | CM.Condition.TSerialized> = (TConditions<TCondition> & {
	byViewId?: Record<string, TConditions<TCondition>>;
});

export interface IMenuViewsComponentConfiguration extends IMenuComponentConfiguration {
	openCloseConditions?: TConditionsPack<CM.Condition.TSerialized> | null;
};

/**
 * Menu  wich open a view on selection.
 * Each view has a title section in the menu
 **/
export abstract class MenuViewsComponent<
	TComponent extends MenuViewsComponent<TComponent, TConfiguration>,
	TConfiguration extends IMenuViewsComponentConfiguration
> extends MenuComponent<HTMLDivElement, TComponent, TConfiguration> {
	currentSections: SectionComponent[] = [];

	openCloseConditions: TConditionsPack<CM.Condition.TCondition> | null;

	/**
	 * Return true if at least one section was opened, false otherwise.
	 **/
	async open(childrenIds: string | string[], isAlreadyChecked: boolean = false): Promise<boolean> {
		childrenIds = Array.isArray(childrenIds) ? childrenIds : [childrenIds];

		if (this.currentSections.length === childrenIds.length
			&& this.currentSections.every(section => childrenIds.includes(section.id))) {
			return false;
		}

		if (!isAlreadyChecked) {
			const openableChildrenIds = await Promise.all(
					childrenIds.map(async id => [id, await this.isOpenable(id)])
				).then(list => list
					.filter(([_, isOpenable]) => isOpenable)
					.map(([id, _]) => id)
				);

			if (openableChildrenIds.length === 0)
				return false;
		}

		this.component_DOM.classList.add('opened');
		return true;
	};

	async isOpenable(childId: string): Promise<boolean> {
		if (this.currentSections.length === 0) {
			return true;
		}

		if (this.openCloseConditions?.opening && !await this.openCloseConditions.opening.evaluate(this, [])) {
			return false;
		}

		if (
			this.openCloseConditions?.byViewId?.[childId]?.opening
			&& !await this.openCloseConditions.byViewId[childId].opening.evaluate(this, [])
		) {
			return false;
		}

		return true;
	};

	async isClosable(childId: string): Promise<boolean> {
		if (this.currentSections.length === 0) {
			return true;
		}

		if (this.openCloseConditions?.closing && !await this.openCloseConditions.closing.evaluate(this, [])) {
			return false;
		}

		if (
			this.openCloseConditions?.byViewId?.[childId]?.closing
			&& !await this.openCloseConditions.byViewId[childId]?.closing?.evaluate(this, [])
		) {
			return false;
		}

		return true;
	};

	/**
	 * Return true if at least one section was closed, false otherwise.
	 **/
	async close(childrenIds: string | string[]): Promise<boolean> {
		childrenIds = Array.isArray(childrenIds) ? childrenIds : [childrenIds];

		const closableChildrenIds = await Promise.all(
				childrenIds.map(async id => [id, await this.isClosable(id)])
			).then(list => list
				.filter(([_, isClosable]) => isClosable)
				.map(([id, _]) => id)
			);

		if (closableChildrenIds.length === 0)
			return false;

		this.component_DOM.classList.remove('opened');
		return true;
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: TConfiguration
	) {
		super(descriptor, configuration);

		this.openCloseConditions = null;

		if (configuration.openCloseConditions) {
			this.openCloseConditions = {};

			if (configuration.openCloseConditions.opening) {
				this.openCloseConditions.opening = CM.Condition.deserialize(configuration.openCloseConditions.opening);
			}

			if (configuration.openCloseConditions.closing) {
				this.openCloseConditions.opening = CM.Condition.deserialize(configuration.openCloseConditions.closing);
			}

			if (configuration.openCloseConditions.byViewId) {
				this.openCloseConditions.byViewId = {};

				for (const [viewId, serializedConditionPack] of Object.entries(configuration.openCloseConditions.byViewId)) {
					const conditionPack: TConditionsPack<CM.Condition.TCondition> = {};

					if (serializedConditionPack.opening) {
						conditionPack.opening = CM.Condition.deserialize(serializedConditionPack.opening);
					}

					if (serializedConditionPack.closing) {
						conditionPack.closing = CM.Condition.deserialize(serializedConditionPack.closing);
					}

					this.openCloseConditions.byViewId[viewId] = conditionPack;
				}
			}
		}
	};
};
export namespace NS {
	export const Component = MenuViewsComponent;
	export type Component = MenuViewsComponent<any, any>;
	export type Configuration = IMenuViewsComponentConfiguration;
}
// CM.declare({
// 	id   : 'menu-views',
// 	type : MenuViewsComponent
// });
// export interface IMenuComponentConfiguration extends CM.IComponentConfiguration {
// };
// export abstract class MenuComponent<
// 	TNode extends HTMLElement,
// 	TConfiguration extends IMenuComponentConfiguration
// > extends CM.DOMComponent<TNode, TConfiguration> {

// 	constructor(
// 		descriptor    : ConstructorParameters<typeof CM.Component>[0],
// 		configuration : TConfiguration
// 	) {
// 		super(descriptor, configuration);
// 	};
// };
// export namespace NS {
// 	export type Configuration = IMenuComponentConfiguration;
// 	export const Component    = MenuComponent;
// 	export type Component<
// 		X extends	HTMLElement,
// 		Y
// 	> = MenuComponent<X, Y>;
// };
// import * as STD from '@libs/UtilSTD/index';
